import { useEffect } from "react";
import { useLoaderData } from "react-router-dom";
import AxiosInstance from "src/components/Axios";

const urlApi = "/options";


export async function LoaderHome({ params }) {
    const role = localStorage.getItem('user_role');
    const tokenStr = localStorage.getItem('user')
    const header = { headers: { Authorization: `Bearer ${tokenStr}`, accept: 'application/json' } }

    if (role && role !== "ROLE_ADMIN") return { data: null };

    const requestParams = {
        option_key: "tehnical_links",
    };

    try {
        const response = await AxiosInstance(urlApi, { params: requestParams, ...header });
        // console.log('response', response);
        return { data: response.data[0] };
    } catch (error) {
        console.error("Помилка запиту за 'Технічними посиланнями':", error);
        return { data: null };
    };
};


const Home = () => {
    const { data } = useLoaderData();

    return (
        <div>
            <div><strong>Вітаємо!</strong></div>

            {
                data && (
                    <div style={{ marginTop: "50px" }}>
                        <hr />
                        <div dangerouslySetInnerHTML={{ __html: data.data }}></div>
                    </div>
                )
            }
        </div>
    );
};

export default Home;